interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "filter (5) 1" asset from the Dimensions table Figma frame (76071:5432). */
const FigmaFilterIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.33333 16C9.18909 16 9.04873 15.9532 8.93333 15.8667L6.26667 13.8667C6.18387 13.8046 6.11667 13.724 6.07038 13.6315C6.0241 13.5389 6 13.4368 6 13.3333V9.58667L1.32267 4.32467C0.99048 3.94992 0.773586 3.48721 0.698053 2.99216C0.62252 2.4971 0.691563 1.99077 0.896882 1.53401C1.1022 1.07725 1.43506 0.689506 1.85545 0.417377C2.27585 0.145248 2.76588 0.000316041 3.26667 0L12.7333 0C13.2341 0.000587129 13.724 0.145759 14.1442 0.418071C14.5644 0.690383 14.8971 1.07825 15.1022 1.53506C15.3073 1.99187 15.3761 2.49818 15.3004 2.99316C15.2247 3.48815 15.0076 3.95073 14.6753 4.32533L10 9.58667V15.3333C10 15.5101 9.92976 15.6797 9.80474 15.8047C9.67971 15.9298 9.51014 16 9.33333 16ZM7.33333 13L8.66667 14V9.33333C8.6668 9.17011 8.72682 9.0126 8.83533 8.89067L13.6807 3.43933C13.8422 3.25672 13.9477 3.03136 13.9843 2.7903C14.0209 2.54924 13.9872 2.30274 13.8872 2.08037C13.7872 1.85801 13.6251 1.66924 13.4204 1.53673C13.2157 1.40421 12.9772 1.33359 12.7333 1.33333H3.26667C3.02297 1.3337 2.78455 1.40436 2.58 1.53684C2.37546 1.66932 2.21347 1.858 2.11347 2.08023C2.01347 2.30247 1.9797 2.54884 2.01622 2.78979C2.05273 3.03074 2.15798 3.25604 2.31933 3.43867L7.16533 8.89067C7.27361 9.0127 7.33338 9.17019 7.33333 9.33333V13Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaFilterIcon;
